import { FC, MouseEvent, useId, useState } from "react";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";

type Props = {
  row: { uniqueId: string };
  actionsMenuLabel: string;
  deleteLabel: string;
  onDelete: (row: { uniqueId: string }) => void;
};

const ObjectTableRowActions: FC<Props> = ({
  row,
  actionsMenuLabel,
  deleteLabel,
  onDelete
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const reactId = useId();
  const menuId = `object-row-actions-menu-${row.uniqueId}-${reactId}`;
  const buttonId = `object-row-actions-button-${row.uniqueId}-${reactId}`;

  const handleOpen = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = (event: MouseEvent) => {
    event.stopPropagation();
    onDelete(row);
    setAnchorEl(null);
  };

  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <IconButton
        id={buttonId}
        size="small"
        aria-label={actionsMenuLabel}
        onClick={handleOpen}
        aria-controls={open ? menuId : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <MoreHoriz fontSize="small" />
      </IconButton>
      <Menu
        id={menuId}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(e) => e.stopPropagation()}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem onClick={handleDelete}>{deleteLabel}</MenuItem>
      </Menu>
    </Box>
  );
};

export default ObjectTableRowActions;
